import { useState } from "react";
import { Button } from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useAuth } from "@/auth/AuthContext";
import NotificationGroupsDialog from "./NotificationGroupsDialog.tsx";

/** Mideye admins only. */
export default function NotificationsButton() {
  const { user, effectiveCompanyId } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user?.is_admin || !effectiveCompanyId) return null;
  return (
    <>
      <Button variant="outlined" size="small" startIcon={<NotificationsNoneIcon />} onClick={() => setOpen(true)}>
        Notifications
      </Button>
      {open && (
        // Keyed by company: switching company drops the open draft and the loaded version with it.
        <NotificationGroupsDialog key={effectiveCompanyId} company={effectiveCompanyId} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
